<template>
  <v-container
    fluid
    class="qa-form" px-5>
    <v-layout>
      <v-flex pt-5>
        <p>Instructions: All fields with <span class="required">*</span> are required to proceed with submission. On some questions, you can click on <v-icon color="orange">info</v-icon> to show more details of the options</p>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex
        md10
        pt-2
        class="d-flex align-center">
        <label>Will this be a customer dedicated Master account?
          <span class="required">*</span>
        </label>
      </v-flex>
      <v-flex
        md2>
        <v-layout 
          column
          align-end>
          <v-flex>
            <v-btn-toggle v-model="request.dedicatedMasterAccount" >
              <v-btn
                value="Yes"
                class="black--text btn--qa">Yes</v-btn>
              <v-btn
                value="No"
                class="black--text btn--qa">No</v-btn>
            </v-btn-toggle>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex md12>
        <v-layout v-if="request.dedicatedMasterAccount=='Yes'">
          <v-flex
            pl-5
            sm12
            md6>
            <label>Please provide the Client's name and SFID ID</label>
            <v-layout align-center mb-2>
              <v-flex md3>
                <label>Client's Name: <span class="required">*</span></label>
              </v-flex>
              <v-flex md9>
                <v-text-field
                  hide-details
                  v-model="request.clientName"
                  placeholder="Client Name"
                  name="Client_Name"
                  solo
                />
              </v-flex>
            </v-layout>
            <v-layout align-center>
              <v-flex md3>
                <label>Client's SFDC ID: <span class="required">*</span></label>
              </v-flex>
              <v-flex md9>
                <v-text-field
                  hide-details
                  v-model="request.clientSfdcid"
                  placeholder="Client Name"
                  name="Client_Name"
                  solo
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout v-if="request.dedicatedMasterAccount=='No'">
          <v-flex
            pl-5
            sm12
            md6>
            <label>Will this be for DXC Interanl buisness? If yes, Provide the service line and BU</label>
            <v-layout align-center mb-2>
              <v-flex md3>
                <label>Service Line: <span class="required">*</span></label>
              </v-flex>
              <v-flex md9>
                <v-text-field
                  hide-details
                  v-model="request.serviceLine"
                  placeholder="Service Line"
                  name="Service_Line"
                  solo
                />
              </v-flex>
            </v-layout>
            <v-layout align-center>
              <v-flex md3>
                <label>Business Unit: <span class="required">*</span></label>
              </v-flex>
              <v-flex md9>
                <v-text-field
                  hide-details
                  v-model="request.businessUnit"
                  placeholder="Business Unit"
                  name="Business_Unit"
                  solo
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap align-center>
              <v-flex
                md8
                pt-2
                class="d-flex align-center">
                <label>Is this delivered under the SaaS model?
                  <span class="required">*</span>
                </label>
              </v-flex>
              <v-flex
                md4>
                <v-layout 
                  column
                  align-end>
                  <v-flex>
                    <v-btn-toggle v-model="request.saasModel" >
                      <v-btn
                        value="Yes"
                        class="black--text btn--qa">Yes</v-btn>
                      <v-btn
                        value="No"
                        class="black--text btn--qa">No</v-btn>
                    </v-btn-toggle>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row wrap align-center>
      <v-flex
        md7
        pt-2>
        <label>What is the account model for this dedicated Master Account?
          <span class="required">*</span>
          <v-icon color="orange" @click="showAccountModelDetails = !showAccountModelDetails" title="Show account model details">info</v-icon>
        </label>
        <div v-if="showAccountModelDetails" class="contract-details-info">
          <p>SPP: The SPP (Service Provider Program) contract is a standard agreement between DXC and AWS providing general discounts. SPP includes all DXC accounts for external clients that do not meet the requirements for the PPA (see below).  SPP may also be referred to as SPA (Service Provider Agreement). Under SPP, DXC sells AWS Services to a DXC client as part of a Solution. The DXC client is under the terms of the agreement between DXC and the client. The client will contact DXC for support questions.</i></p>

          <p>PPA: The PPA (Preferred Pricing Agreement) is an agreement between DXC and AWS that provides for special discounts and account support. All DXC Internal accounts and DXC Software as a Service (SaaS) accounts will by default fall under the PPA master account structure. External client accounts MUST be approved through the OppReg process, and meet specific eligibility criteria, before they are onboarded to a PPA External Master Account.</i></p>

        </div>
      </v-flex>
      <v-flex
        md5>
        <v-layout 
          column
          align-end>
          <v-flex>
            <v-radio-group row v-model="request.accountModel" >
              <v-radio
                color="primary"
                label="SPP"
                value="SPP"
              />
              <v-radio
                color="primary"
                label="PPA"
                value="PPA"
              />
            </v-radio-group>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex md6 v-if="request.accountModel=='PPA'">
        <v-layout>
          <v-flex
            pl-5
            sm12
            md12>
            <label>Please specify business justification:<span class="required">*</span></label>
            <v-textarea 
              v-model="request.businessJustification"
              placeholder="Business Justification"
              solo />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout v-if="request.dedicatedMasterAccount=='Yes'" row wrap  align-center>
      <v-flex
        md7>
        <label>What is the contract type for this SPP Master Account?
          <span class="required">*</span>
          <v-icon color="orange" @click="showContractTypeDetails = !showContractTypeDetails" title="Show contract type details">info</v-icon>
        </label>
        <div v-if="showContractTypeDetails" class="contract-details-info">
          <p><i>Partner = Support and servicing is led by DXC as the AWS</i></p>
          <p><i>Partner resold = Support and servicing is led by the customer as a resold account</i></p>
          <p><i>Ecam-partner = Support and servicing is led by DXC as the AWS partner under the End Customer Account Model</i></p>
          <p><i>Ecam-resold = Support and servicing is led by the customer as a resold account under the End Customer Account Model</i></p>
        </div>
      </v-flex>
      <v-flex
        md5>
        <v-layout 
          column
          align-end>
          <v-flex>
            <v-radio-group row v-model="request.sppContractType" >
              <v-radio
                color="primary"
                label="Partner"
                value="Partner"
              />
              <v-radio
                color="primary"
                label="Resold"
                value="Resold"
              />
              <v-radio
                color="primary"
                label="Ecam Partner"
                value="Ecam Partner"
              />
              <v-radio
                color="primary"
                label="Ecam Resold"
                value="Ecam Resold"
              />
            </v-radio-group>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex
        md6
        pt-2
        class="flex-column">
        <label class="d-block">What AWS Support level is required for this dedicated Master Account?
          <span class="required">*</span>
        </label>
        <small>Note - All lined accounts will same support as their Master Payer</small>
      </v-flex>
      <v-flex
        md6>
        <v-layout 
          column
          align-end>
          <v-flex>
            <v-radio-group row v-model="request.awsSupportLevel" >
              <v-radio
                color="primary"
                label="Enterprise"
                value="Enterprise"
              />
              <v-radio
                v-if="request.sppContractType !='Partner'"
                color="primary"
                label="Developer"
                value="Developer"
              />
              <v-radio
                v-if="request.sppContractType !='Partner'"
                color="primary"
                label="Business"
                value="Business"
              />
              <v-radio
                v-if="request.sppContractType !='Partner'"
                color="primary"
                label="Basic"
                value="Basic"
              />
            </v-radio-group>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row align-center>
      <v-flex
        md6
        pt-2
        class="flex-column">
        <label class="d-block">Will the linked accounts for this Master Payer be:
          <span class="required">*</span>
        </label>
      </v-flex>
      <v-flex
        md6>
        <v-layout 
          column
          align-end>
          <v-flex>
            <v-radio-group v-model="request.linkedAccountsType" >
              <v-radio
                color="primary"
                label="New DXC-created Linked (Child) accounts"
                value="New"
              />
              <v-radio
                color="primary"
                label="Accounts transferred from the customer (ShareShift)"
                value="Transferred"
              />
            </v-radio-group>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex
        md9
        pt-2
        class="d-flex align-center">
        <label>What is the contract signature date?  What date do services begin?
          <span class="required">*</span>
        </label>
      </v-flex>
      <v-flex
        md3>
        <v-menu
          v-model="contractSignatureDateModal"
          :close-on-content-click="false"
          :nudge-left="200"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="request.contractSignatureDate"
              label="Contract Signature Date"
              prepend-icon="event"
              clearable
              readonly
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="request.contractSignatureDate"
            @input="contractSignatureDateModal = false"/>
        </v-menu>
      </v-flex>
    </v-layout>
    <v-layout row align-center>
      <v-flex
        md8
        pt-2
        class="d-flex align-center">
        <label>What is your Opportunity Registration / Opportunity ID?
          <span class="required">*</span>
        </label>
      </v-flex>
      <v-flex
        md4>
        <v-text-field
          hide-details
          v-model="request.opportunityId"
          placeholder="Opportunity ID"
          name="Opportunity_ID"
          solo
        />
      </v-flex>
    </v-layout>
    <v-layout row align-center>
      <v-flex
        md10
        pt-2
        class="flex-column">
        <label class="d-block">Does this customer have it’s own EDP contract?
          <span class="required">*</span>
        </label>
        <small>Note: edp = Enterprise Discount Plan, master account for a specific customer or group of customers under a dedicated AWS agreement (not the DXC PPA or SPP agreements)</small>
      </v-flex>
      <v-flex
        md2>
        <v-layout 
          column
          align-end>
          <v-flex>
            <v-btn-toggle v-model="request.edpContract" >
              <v-btn
                id="q9"
                value="Yes"
                class="black--text btn--qa">Yes</v-btn>
              <v-btn
                value="No"
                class="black--text btn--qa">No</v-btn>
            </v-btn-toggle>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex
        md10
        pt-2
        class="d-flex align-center">
        <label>Is there a Control tower required as part of MP?
          <span class="required">*</span>
        </label>
      </v-flex>
      <v-flex
        md2>
        <v-layout 
          column
          align-end>
          <v-flex>
            <v-btn-toggle v-model="request.controlTowerRequired" >
              <v-btn
                value="Yes"
                class="black--text btn--qa">Yes</v-btn>
              <v-btn
                value="No"
                class="black--text btn--qa">No</v-btn>
            </v-btn-toggle>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex md12>
        <v-layout v-if="request.controlTowerRequired=='Yes'">
          <v-flex
            pl-5
            sm12
            md6>
            <label>What are the regions they want to enable control tower?</label>
            <v-layout align-center mb-2>
              <v-flex md12>
                <v-autocomplete
                  v-model.lazy="request.controlTowerRegions"
                  :hint="'Select regions. Click the icon on the right to view the full list'"
                  :items="awsRegions"
                  item-text="label"
                  item-value="value"
                  persistent-hint
                  style="margin-top: 0; padding-top: 5px"
                  open-on-clear
                  attach
                  multiple
                  chips
                  small-chips
                  solo
                >
                  <!-- <template v-slot:selection="data">
                    {{ data.item }}
                  </template> -->
                  <!-- <template v-slot:append-outer>
                    <v-icon
                      color="orange"
                      @click="onFullView"
                      v-text="'mdi-view-list'"
                    ></v-icon>
                  </template> -->
                </v-autocomplete>

                <!-- <v-text-field
                  hide-details
                  v-model="controlTowerRegions"
                  placeholder="Regions"
                  name="Regions"
                  solo
                /> -->
              </v-flex>
            </v-layout>
            <v-layout align-center>
              <v-flex md6>
                <label>Guard Rail?</label>
              </v-flex>
              <v-flex md6>
                <v-radio-group row v-model="request.controlTowerGuardRail" >
                  <v-radio
                    color="primary"
                    label="Yes"
                    value="Yes"
                  />
                  <v-radio
                    color="primary"
                    label="No"
                    value="No"
                  />
                </v-radio-group>    
              </v-flex>
            </v-layout>
            <v-layout align-center>
              <v-flex md6>
                <label>Cloud Trail?</label>
              </v-flex>
              <v-flex md6>
                <v-radio-group row v-model="request.controlTowerCloudTrail" >
                  <v-radio
                    color="primary"
                    label="Yes"
                    value="Yes"
                  />
                  <v-radio
                    color="primary"
                    label="No"
                    value="No"
                  />
                </v-radio-group>    
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <h4>Attestation</h4>
    <v-layout row wrap>
      <v-flex
        md6>
        <v-text-field
          v-model="requestorName"
          label="Requestor Name"
          solo
        />
      </v-flex>
      <v-flex
        md6>
        <v-text-field
          v-model="requestorEmail"
          label="Requestor Email"
          solo
        />
      </v-flex>
    </v-layout>
    <v-layout justify-center>
      <v-btn class="success" :disabled="incompleteInputs" @click="onSubmit" :loading="submitting">SUBMIT</v-btn>
    </v-layout>
  </v-container>
</template>

<script>
// Utilities
import {
  mapMutations,
  mapState,
  mapActions
} from 'vuex'

export default {
  data() {
    return {
      awsRegions: [
        {
          label: 'us-east-1 (N. Virginia)',
          value: 'us-east-1'
        },
        {
          label: 'us-east-2 (Ohio)',
          value: 'us-east-2'
        },
        {
          label: 'us-west-1 (N. California)',
          value: 'us-west-1'
        },
        {
          label: 'us-west-2 (Oregon)',
          value: 'us-west-2'
        },
        {
          label: 'us-gov-west-1 (US GovCloud West)',
          value: 'us-gov-west-1'
        },
        {
          label: 'us-gov-east-1 (US GovCloud East)',
          value: 'us-gove-east-1'
        },
        {
          label: 'ca-central-1 (Canada)',
          value: 'ca-central-1'
        },
        {
          label: 'eu-north-1 (Stockholm)',
          value: 'eu-north-1'
        },
        {
          label: 'eu-west-1 (Ireland)',
          value: 'eu-west-1'
        },
        {
          label: 'eu-west-2 (London)',
          value: 'eu-west-2'
        },
        {
          label: 'eu-west-3 (Paris)',
          value: 'eu-west-3'
        },
        {
          label: 'eu-central-1 (Frankfurt)',
          value: 'eu-central-1'
        },
        {
          label: 'eu-south-1 (Milan)',
          value: 'eu-south-1'
        },
        {
          label: 'eu-south-2 (Europe Spain)',
          value: 'eu-south-2'
        },
        {
          label: 'af-south-1 (Cape Town)',
          value: 'af-south-1'
        },
        {
          label: 'ap-northeast-1 (Tokyo)',
          value: 'ap-northeast-1'
        },
        {
          label: 'ap-northeast-2 (Seoul)',
          value: 'ap-northeast-2'
        },
        {
          label: 'ap-northeast-3 (Osaka)',
          value: 'ap-northeast-3'
        },
        {
          label: 'ap-southeast-1 (Singapore)',
          value: 'ap-southeast-1'
        },
        {
          label: 'ap-southeast-2 (Sydney)',
          value: 'ap-southeast-2'
        },
        {
          label: 'ap-east-1 (Hong Kong)',
          value: 'ap-east-1'
        },
        {
          label: 'ap-south-1 (Mumbai)',
          value: 'ap-south-1'
        },
        {
          label: 'me-south-1 (Bahrain)',
          value: 'me-south-1'
        },
        {
          label: 'sa-east-1 (São Paulo)',
          value: 'sa-east-1'
        },
        {
          label: 'cn-north-1 (Bejing)',
          value: 'cn-north-1'
        },
        {
          label: 'cn-northwest-1 (Ningxia)',
          value: 'cn-northwest-1'
        },
        {
          label: 'ap-southeast-3 (Jakarta)',
          value: 'ap-southeast-3'
        }
      ],
      requestorName: null,
      requestorEmail: null,
      contractSignatureDateModal: false,
      showAccountModelDetails: false,
      showContractTypeDetails: false
    }
  },
  mounted() {
    console.log(this.$store.state.currentUser)
    this.requestorName = this.$store.state.currentUser.name
    this.requestorEmail = this.$store.state.currentUser.email
    this.request.requestorId = this.$store.state.currentUser.requestor_id
  },
  computed: {
    ...mapState('user/requestMasterpayer', ['submitting','request']),
    incompleteInputs() {
      if (!this.request.dedicatedMasterAccount || !this.request.accountModel || !this.request.awsSupportLevel || !this.request.linkedAccountsType || !this.request.contractSignatureDate || !this.request.opportunityId || !this.request.edpContract || !this.request.controlTowerRequired) {
        return true
      }

      if (this.request.dedicatedMasterAccount === 'Yes') {
        if ( !this.request.clientName || !this.request.clientSfdcid || !this.request.sppContractType) {
          return true
        }
      } else if (this.request.dedicatedMasterAccount === 'No') {
        if ( !this.request.serviceLine || !this.request.businessUnit || !this.request.saasModel ) {
          return true
        }
      }

      if (this.request.accountModel === 'PPA') {
        if (!this.request.businessJustification) {
          return true
        }
      }

      if (this.request.controlTowerRequired === 'Yes') {
        console.log(this.request.controlTowerRegions)

        if (this.request.controlTowerRegions.length === 0 || !this.request.controlTowerGuardRail || !this.request.controlTowerCloudTrail) {
          return true
        }
      }

      // everything valid
      return false
    }
  },
  methods: {
    ...mapActions({
      masterpayerSubmit: 'user/requestMasterpayer/submitMasterpayer'
    }),
    onSubmit() {

      let masterpayerData = {
        ...this.request
      }
      console.log('submitting form')
      this.masterpayerSubmit(masterpayerData)
    }
  },
  watch: {
    'request.sppContractType'(value) {
      if (value === 'Partner') {
        this.request.awsSupportLevel = 'Enterprise'
      } else {
        this.request.awsSupportLevel = ''
      }
    },
  }
}

</script>
<style lang="scss" scoped>
.dash {
  position: relative;
  padding-bottom:100px;
  top: 25%;
}

.qa-form {
  max-width: 1500px;
  font-size: 20px;
  .v-btn-toggle{ margin:10px 0}
  .v-btn-toggle .v-btn{
    padding: 15px 38px;
    opacity: 1;
  }
  
  .btn--qa{
    font-weight: bold !important;
  }

  .v-select--width{
    width: 100%;
  }

  span{
    &.workload-desc{
      font-weight:600
    }
  }

  div {
    &.qa-desc{
      font-style: italic;
      font-size: 14px;
    }
  }
  .input-symbol-dollar {
      position: relative;
      display: block;
    }
    .input-symbol-dollar:after {
        color: #37424a !important;
        content: "$";
        font-size: 16px !important;
        font-weight: 400;
        position: absolute;
        display: block;
        height: 100%;
        top: 0;
        left: 10px;
        line-height: 42px;
    }
    .padding-left-15.v-text-field input{
      padding-left:15px;
      background: yellow;
    }
    // .theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat){
    //   background-color: grey;
    // }
    .v-btn--active:before, .v-btn:focus:before, .v-btn:hover:before{
      background-color: grey;
    }
      .opp-btn {
      width: 200px;
    }
  
  .contract-details-info {
    border: 2px dashed #5a5a5a; 
    padding: 10px;
  }
}
</style>
